import * as Factory from 'factory.ts'
import faker from 'faker'

import { AccountMock } from './account.factory'
import { type APCost } from '../../models'

export const APCostMock = Factory.Sync.makeFactory<APCost>({
  id: Factory.each(() => faker.random.number()),
  active: true,
  budget: AccountMock.build(),
  name: Factory.each(
    () => `${faker.finance.currencyCode()} ${faker.finance.currencySymbol()}`
  ),
})
